import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// API methods
export const metricsAPI = {
  getDashboard: () => api.get('/metrics/dashboard'),
  getDashboardV2: () => api.get('/metrics/dashboard-v2'),
  getRevenue: () => api.get('/metrics/revenue'),
  refresh: () => api.post('/metrics/refresh')
};

export const subscriptionsAPI = {
  getAll: (params) => api.get('/subscriptions', { params }),
  getActive: () => api.get('/subscriptions/active'),
  getCancelled: () => api.get('/subscriptions/cancelled'),
  getById: (id) => api.get(`/subscriptions/${id}`),
  getDetails: (id) => api.get(`/subscriptions/${id}/details`),
  getSource: (id) => api.get(`/subscriptions/${id}/source`),
  updateSource: (id, salesperson) => api.put(`/subscriptions/${id}/source`, { salesperson }),
  clearSource: (id) => api.delete(`/subscriptions/${id}/source`)
};

export const commissionsAPI = {
  getAll: (params) => api.get('/commissions', { params }),
  getBySalesperson: (name) => api.get(`/commissions/${name}`)
};

export default api;
